/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronDownToDoubleLine: {
  name: 'chevron-down-to-double-line';
  data: string;
} = {
  name: 'chevron-down-to-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.293 5.293a1 1 0 0 1 1.414 0L12 8.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414ZM7 14a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z" fill="currentColor"/></svg>`,
};
